<template>
  <b-sidebar
    id="sidebar-create-direction"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ $t('Direction') }}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="clear(hide)"
        />

      </div>

      <!-- Body -->
      <b-form
        class="p-2"
        @submit.prevent
      >
        <!-- Direction -->
        <b-form-group
          :label="$t('Direction')"
          label-for="direction"
        >
          <v-select
            id="direction"
            v-model="direction.direction"
            :reduce="(option) => option.id"
            :options="directions"
            :get-option-label="(option) => option.name[$i18n.locale] +' ('+ option.code + ')'"
          />
        </b-form-group>

        <!-- Form Actions -->
        <div class="d-flex mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2"
            type="submit"
            @click="submit(hide)"
          >
            {{ direction.id ? $t('Update') : $t('Create') }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="clear(hide)"
          >
            {{ $t('Cancel') }}
          </b-button>
        </div>
      </b-form>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BButton, BForm, BFormGroup, BSidebar,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BButton,
    vSelect,
  },
  directives: {
    Ripple,
  },
  computed: {
    direction: {
      get() {
        return this.$store.state[this.MODULE_NAME].org_direction
      },
      set(data) {
        this.$store.commit(`${this.MODULE_NAME}/UPDATE`, data)
      },
    },
    directions() {
      return this.$store.state.direction.directions
    },
  },
  created() {
  },
  methods: {
    clear(hide) {
      this.$store.commit(`${this.MODULE_NAME}/FRESH`)
      hide()
    },
    submit(hide) {
      this.direction.org = this.$route.params.id
      this.$confirmCode({
        callback: (confirm, smsCode) => {
          if (confirm) {
            this.$createSwal(this, { ...this.direction, smsCode }, `${this.MODULE_NAME}/${this.direction.id ? 'update' : 'create'}`, () => {
              this.$emit('refetchData')
              this.$store.commit(`${this.MODULE_NAME}/FRESH`)
            })
            hide()
          }
        },
      })
    },
  },
  setup() {
    const MODULE_NAME = 'organizationDirection'
    return {
      MODULE_NAME,
    }
  },
}
</script>
